<template>
	<div v-loading="loading" :style="{
		minHeight: equipment == 'pc'?'500px':'100vh'
	}" style="user-select:text;width: 100%;background-color: #fff;margin-top: 20px;">
		<div
			style="height: 140px;font-size: 14px;display: flex;align-items: center;background-color: #f8f9fa;padding-left: 20px;">
			<img style="width: 100px;height: 100px;object-fit: contain;border: solid 1px #dedede;" :src="form.avatar"  v-if="form.avatar"/>
			<img style="width: 100px;height: 100px;object-fit: contain;border: solid 1px #dedede;" src="../../img/tx.png"   v-if="!form.avatar"/>
			<div style="margin-left: 20px;">
				<el-upload :show-file-list="false" class="upload-demo" ref="upload" action="" :onChange="changeFile"
					:file-list="fileList" :before-upload="beforeAvatarUpload" :auto-upload="false">
					<el-button class="btn" size="mini" icon="el-icon-refresh">{{$t('h.changeHeadImg')}}</el-button>
					<div slot="tip" class="el-upload__tip">{{$t('h.uploadTit')}}</div>
				</el-upload>
			</div>

		</div>
		<div style="font-size: 14px;">
			<div>{{$t('h.name')}}</div>
			<el-input style="margin-top: 10px;" v-model="form.name" :placeholder="$t('h.name')"></el-input>
			<!-- <div style="margin-top: 15px;">{{$t('h.email')}}</div> -->
			<!-- <el-input style="margin-top: 10px;" v-model="form.email" :placeholder="$t('h.email')"></el-input> -->

			<el-button class="btn-ok" style="background-color: #000;border: solid 1px #000;margin-top: 20px;width: 40%;"
				type="primary" @click="submit">{{$t('h.confirm')}}</el-button>
		</div>


		<el-dialog v-loading="loading" :title="$t('h.tips')" :visible.sync="dialogVisible" :width="equipment == 'pc'?'30%':'90%'"
			:before-close="()=>{dialogVisible = false;fileList = [];option.img = ''}">
			<div style="height: 300px;font-size: 14px;">
				<vue-cropper infoTrue centerBox autoCrop ref="cropper" fixed :canMove="false" :img="option.img"
					:infoTrue="option.infoTrue" :full="option.full">
				</vue-cropper>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="btn" @click="dialogVisible = false;fileList = [];option.img = ''">{{$t('h.cancel')}}</el-button>
				<el-button class="btn-ok" style="background-color: #000;border: solid 1px #000;" type="primary"
					@click="cropperImg">{{$t('h.confirm')}}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		VueCropper
	} from 'vue-cropper'

	import {
		getaccountfiles,
		getaccountUpdateData
	} from '../../../../api/all.js'


	export default {
		components: {
			VueCropper
		},
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			userInfo: {
				type: Object,
				default: () => {
					return {}
				}
			},

		},
		watch: {
			userInfo: {
				immediate: true,
				deep: true,
				handler: async function(newValue, oldValue) {
					this.form = {
						...newValue
					}
				}
			}
		},
		data() {
			return {
				loading: false,
				imgName: "",
				form: {
					avatar: "",
					name: "",
					email: ""
				},
				dialogVisible: false,
				fileList: [],
				option: {
					img: '',
					outputType: 'jpg',
					infoTrue: true,
					full: false,
					fixedBox: true,
					original: true,
					centerBox: true,
					limitMinSize: 300
				}
			}
		},
		mounted() {

		},
		methods: {
			cropperImg(e) {

				this.$refs.cropper.getCropData(async data => {
					this.loading = true
					try {
						// do something
						const formData = new FormData();
						formData.append('file', this.dataURLtoFile(data, this.imgName))
						formData.append('type', 'avatar')

						let imgUpload = await getaccountfiles({
							formData
						})
						this.form.avatar = imgUpload.data.data.url
						this.dialogVisible = false
						this.loading = false
					} catch (e) {
						this.loading = false
					}
				})
			},
			async submit() {
				if (this.form.name == '') {
					this.$message.error(this.$t('h.nameError'))
					return
				}
				if (this.form.email == '') {
					this.$message.error(this.$t('h.errorEmail'))
					return
				}
				try {
					this.loading = true
					const data = await getaccountUpdateData(this.form)
					this.$message.success(data.data.message)
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			},
			changeFile(file) {
				console.log('file', file)
				// this.imgName = file.name.substring(0, file.name.lastIndexOf("."))
				this.imgName = file.name
				this.dialogVisible = true
				// 点击弹出剪裁框
				this.$nextTick(() => {
					this.option.img = window.URL.createObjectURL(file.raw) // 将图片转化为路径
					console.log('this.option.img', this.option.img)
				})
			},
			beforeAvatarUpload(file) {
				// 上传前校验
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
				const isLt2M = file.size / 1024 / 1024 < 2

				if (!isJPG) {
					
					this.$message.error(this.$t('h.imgTypeTips'))
				}
				if (!isLt2M) {
					this.$message.error(this.$t('h.imgSizeTips'))
				}
				// 校验通过后显示裁剪框
				return false
			},
			// 将base64转换为文件
			dataURLtoFile(dataurl, filename) {
				let arr = dataurl.split(',')
				let mime = arr[0].match(/:(.*?);/)[1]
				let bstr = atob(arr[1])
				let len = bstr.length
				let u8arr = new Uint8Array(len)
				while (len--) {
					u8arr[len] = bstr.charCodeAt(len)
				}
				return new File([u8arr], filename, {
					type: mime
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.btn:hover {
		background-color: #fff;
		color: #000;
		border: solid 1px #e5e5e5;
	}

	.btn:focus {
		background-color: #fff;
		color: #000;
		border: solid 1px #e5e5e5;
	}

	.btn-ok:hover {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}

	.btn-ok:focus {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}
</style>